// FILE: _chat.threads.tsx
// Purpose: Registers the "Todos los hilos" section under the shared chat shell, with its filters
//          parsed off the URL.
// Layer: Route
// Exports: Route

import { createFileRoute } from "@tanstack/react-router";
import { ThreadDirectoryView } from "~/components/threadDirectory/ThreadDirectoryView";
import { parseThreadDirectoryRouteSearch } from "~/lib/threadDirectoryRouteSearch";

// Never throws: an unreadable filter falls back to the default view rather than to an error page,
// because a link somebody edited by hand should still show a list. The permission is enforced by
// the server on every read — the sidebar entry is hidden without it, and the route is unreachable
// in practice, but a typed URL must fail on the answer and not on the render.
export const Route = createFileRoute("/_chat/threads")({
  validateSearch: (search) => parseThreadDirectoryRouteSearch(search),
  component: ThreadDirectoryView,
});
